module.exports = __webpack_public_path__ + "static/media/news-small-placeholder.923f7a37.webp";